import { ScheduleNotificationType } from '../enum/schedule-notification-type.enum';

export const ScheduleNotificationIcon = (type: ScheduleNotificationType) => {
    switch (type) {
        case ScheduleNotificationType.warning:
            return 'assets/icons/warning.svg';
        case ScheduleNotificationType.promotion:
            return 'assets/icons/promotion.svg';
        case ScheduleNotificationType.notice:
            return 'assets/icons/notice.svg';
        case ScheduleNotificationType.post:
            return 'assets/icons/post.svg';
        default:
            return null;
    }
};
